export default __webpack_public_path__ + "static/media/avatar.4121f7e3.svg";